var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgK1Gift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 29v14h5v18h40V43h5V29H13zm23 28H22V43h14v14zm0-18H17v-6h19v6zm18 18H40V43h14v14zm5-18H40v-6h19v6zM26.49 26h23a6.91 6.91 0 10-5.59-11L38 22l-5.89-7a6.93 6.93 0 00-9-2 6.83 6.83 0 00-3.4 4.57A6.931 6.931 0 0026.49 26zm20.64-8.79a2.92 2.92 0 015.28 1.7c0 1.61-.79 2.91-2.41 3.09h-6.3l3.43-4.79zm-23.49 1.13a2.91 2.91 0 015.24-1.13L32.3 22H26c-1.78-.19-2.7-1.81-2.36-3.66z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/K1_Gift.fb312d30.svg";
export { SvgK1Gift as ReactComponent };